import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import classes from './MegaFilterContainer.module.css'
import SelectedFiltersDisplayMultiple from "../filters/SelectedFiltersDisplayMultiple"
import { getItemFromStorageSimple, removeStorageItem } from "../../../lib/script"
import { filterActions } from "../../../store/filter"
import Button from "../../common/Button"
import OutsideClickComponent from "../../fragments/OutsideClickComponent"
import MegaMasterFilters from "./MegaMasterFilters"
import { workqueueActions } from "../../../store/workqueue"
import { applyStandardWorkQueueDefaults, isMeaningfulWorkQFilterValue, setFiltersInLocalStorage } from "../../../lib/filters"
import { SaveWorkQueueViewButton } from "../filters/SavedViewBanner"
import { reduceToIdArray } from "../../../lib/script"
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3"
import { detailedSearchOptions } from "../../../assets/data"
import { fetchWorkQNow } from "../../../lib/hooks"
import FilterSearchContainer from "./searchbox/FilterSearchContainer"
import {
    getCollectionRepDismissedForWorkQ,
    markCollectionRepDismissed,
} from "../../../lib/workQ"

function buildCurrentUserCollectionsFilterOption(user) {
    if (!user?.id) {
        return null
    }

    const fallbackName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim()
    const label = user?.name || fallbackName || user?.email || user?.username

    if (!label) {
        return null
    }

    const item = {
        id: user.id,
        value: user.id,
        label: label,
        tag: 'collections'
    }

    return {
        value: user.id,
        label: label,
        item: item,
        async: true
    }
}

export default function MegaFilterContainer({workQ}) {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)
    const selectedFilters = useSelector(state => state.filter.filters)
    const searchParams = useSelector(state => state.filter.searchParams)


    const [showModal, setShowModal] = useState(false)
    const [filtersValues, setFiltersValues] = useState(null)
    const [skipAutoCollectionRep, setSkipAutoCollectionRep] = useState(false)
    const prevHasCollectionRepRef = useRef(false)
    const detailedSearchApiProps = detailedSearchOptions.map(option => option.apiProp)


    function openModalHandler() {
        setShowModal(true)
    }
    function closeModalHandler() {
        setShowModal(false)
        setFiltersValues(selectedFilters)
    }

    function clearAllFiltersHandler() {
        let filters = {}
        if (user && user.locations && user.locations.length) {
            filters.location = reduceToIdArray(user.locations)
        }
        dispatch(filterActions.setFiltersMultiple(filters))
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1

        // remove the local storage if any 
        removeStorageItem(workQ?.slug)
        
        setShowModal(false)
    }

    function isMeaningfulFilterValue(v) {
        return isMeaningfulWorkQFilterValue(v)
    }

    function mainSelectAction(value) {
        let updateobject = {
            ...filtersValues
        }     
        
        let update = JSON.parse(JSON.stringify(updateobject))

        //need to expand the object and include name of the selected options!
        if (value?.data?.value?.constructor == Array) { // check if array
            if (value.data.value.length) {
                update[value.identifier.type] = value.data.value
            } else {
                delete update[value.identifier.type]
            }

        } else {
            if (isMeaningfulFilterValue(value?.data?.value) || value?.data?.value === 0) {
                update[value.identifier.type] = value.data.value
            } else {
                delete update[value.identifier.type]
            }

            if (value.identifier.type == 'do_not_lien') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            if (value.identifier.type == 'ihc_review') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            
        }

        if (value.identifier.type == 'payer_type') { // if it is payer_type reset the payer status!!!!
            delete update.payer_status
        }

        setFiltersValues(update)
    }

    function generalAsyncSearchFilter(value) {
        const isCollectionRepFilter = value?.identifier?.type === 'attorney_collection_rep'
        const isClearingCollectionRep = value?.data?.value?.constructor === Array && !value.data.value.length

        if (isCollectionRepFilter && isClearingCollectionRep && workQ?.slug) {
            markCollectionRepDismissed(workQ.slug)
        }

        let update = {
            ...filtersValues
        }

        if (value?.data?.value?.constructor == Array) { // check if array
            if (value.data.value.length) {
                const filterKey = value.identifier.type
                if (filterKey === 'attorney_collection_rep') {
                    update[filterKey] = value.data.value.map((option) => ({
                        value: option.value ?? option.id,
                        item: option,
                        label: option.label,
                        async: true,
                    }))
                } else {
                    update[filterKey] = value.data.value
                }
            } else {
                delete update[value.identifier.type]
            }

        } else {
            if (isCollectionRepFilter && workQ?.slug) {
                markCollectionRepDismissed(workQ.slug)
            }

            if (update[value.identifier.type]) {
                update[value.identifier.type] = [  
                    ...update[value.identifier.type],          
                    {
                        value: value.data.value.id,
                        item: value.option,
                        label: value.option.label,
                        async: true
                    }
                ]
            } else {
                update[value.identifier.type] = [          
                    {
                        value: value.data.value.id,
                        item: value.option,
                        label: value.option.label,
                        async: true
                    }
                ]
            }  
            
        }    


        setFiltersValues(update)

        if (!showModal) {
            commitFiltersToReduxAndStorage(update)
        }
    }

    function commitFiltersToReduxAndStorage(update) {
        dispatch(filterActions.setFiltersMultiple(update))
        dispatch(filterActions.setCurrentPage(1))
        dispatch(workqueueActions.setRefreshApi())

        if (!workQ?.slug) {
            return
        }

        const filterKeysToRemove = [...detailedSearchApiProps, 'search', 'search_global']
        const persistedFilters = { ...update }
        filterKeysToRemove.forEach((key) => {
            if (key in persistedFilters) {
                delete persistedFilters[key]
            }
        })
        for (const [key, val] of Object.entries(persistedFilters)) {
            if (!isMeaningfulFilterValue(val) && val !== 0) {
                delete persistedFilters[key]
            }
        }
        try {
            setFiltersInLocalStorage(persistedFilters, workQ.slug)
        } catch (e) {
            // ignore storage errors (private mode / quota)
        }
    }

    function payerTypeStatusAction(value) {
        let updateobject = {
            ...filtersValues
        }        

        let update = JSON.parse(JSON.stringify(updateobject))    

        let payer_type_filters = update?.payer_type_filters ? update?.payer_type_filters : []

    
        if (!payer_type_filters.length) {
            payer_type_filters.push({
                payer_type_id: value.data.value,
                payer_status_id: null
            })
            
        } else {        
            if (payer_type_filters[value.identifier.index]) {
                if (value.data.value === null && value.identifier.type == 'payer_type') { //on null I should remove the array item alltogether
                    // delete payer_type_filters[value.identifier.index]
                    payer_type_filters.splice(value.identifier.index, 1)
                } else {
                    payer_type_filters[value.identifier.index][value.identifier.type + '_id'] = value.data.value
            
                    // && !value.data.value
                    if (value.identifier.type == 'payer_type' ) {
                        payer_type_filters[value.identifier.index].payer_status_id = null
                    }
                }
            } else {
                payer_type_filters.push({
                    payer_type_id: value.data.value,
                    payer_status_id: null
                })
                payer_type_filters[value.identifier.index][value.identifier.type + '_id'] = value.data.value
                if (value.identifier.type == 'payer_type' ) {
                    payer_type_filters[value.identifier.index].payer_status_id = null
                }
            }
        }

        update.payer_type_filters = payer_type_filters

        setFiltersValues(update)
    }

    function removepayerTypeStatusAction(value) {
        let updateobject = {
            ...filtersValues
        }        

        let update = JSON.parse(JSON.stringify(updateobject))    

        let payer_type_filters = update?.payer_type_filters ? update?.payer_type_filters : []

        payer_type_filters.splice(value.identifier.index, 1)

        update.payer_type_filters = payer_type_filters

        setFiltersValues(update)
    }

    function practicePatientStatusAction(value) {
        let updateobject = {
            ...filtersValues
        }

        let update = JSON.parse(JSON.stringify(updateobject))
        let practice_patient_status_filters = update?.practice_patient_status_filters ? update?.practice_patient_status_filters : []

        if (!practice_patient_status_filters.length) {
            practice_patient_status_filters.push({
                practice_id: value.data.value,
                practice_patient_status_id: null
            })
        } else {
            if (practice_patient_status_filters[value.identifier.index]) {
                if (value.data.value === null && value.identifier.type == 'practice') {
                    practice_patient_status_filters.splice(value.identifier.index, 1)
                } else {
                    practice_patient_status_filters[value.identifier.index][value.identifier.type + '_id'] = value.data.value

                    if (value.identifier.type == 'practice') {
                        practice_patient_status_filters[value.identifier.index].practice_patient_status_id = null
                    }
                }
            } else {
                practice_patient_status_filters.push({
                    practice_id: value.data.value,
                    practice_patient_status_id: null
                })
                practice_patient_status_filters[value.identifier.index][value.identifier.type + '_id'] = value.data.value
                if (value.identifier.type == 'practice') {
                    practice_patient_status_filters[value.identifier.index].practice_patient_status_id = null
                }
            }
        }

        practice_patient_status_filters = practice_patient_status_filters.filter(item => item?.practice_id)
        if (practice_patient_status_filters.length) {
            update.practice_patient_status_filters = practice_patient_status_filters
            update.practice_patient_status_filters_match = update.practice_patient_status_filters_match || workQ?.filter_conditions?.practice_patient_status_filters_match || 'and'
        } else {
            delete update.practice_patient_status_filters
            delete update.practice_patient_status_filters_match
        }

        setFiltersValues(update)
    }

    // form apply filters
    function setFiltersHandler() {
        const startedAt = typeof performance !== 'undefined' ? performance.now() : Date.now()
        const hasCollectionsRepFilter = workQ?.filter_groups?.some(filter => filter?.key === 'attorney_collection_rep')
        const hasCollectionRepInApply = Array.isArray(filtersValues?.attorney_collection_rep) && filtersValues.attorney_collection_rep.length > 0

        if (hasCollectionsRepFilter && workQ?.slug && !hasCollectionRepInApply) {
            markCollectionRepDismissed(workQ.slug)
        }

        dispatch(filterActions.setMasterLoading(true))
        setShowModal(false)

        // Start the API request immediately (don’t wait for useEffect).
        if (typeof window !== 'undefined') {
            window.__skipNextWorkQFetch = { slug: workQ?.slug, at: startedAt }
        }
        fetchWorkQNow(workQ?.slug, { filters: filtersValues, onPage: 1 })

        // Update Redux state after the request is kicked off.
        setTimeout(() => {
            dispatch(filterActions.setFiltersMultiple(filtersValues))
            dispatch(filterActions.setCurrentPage(1)) //set the page to 1 to avoid pagination issues
        }, 0)

        // (no logging)
        
        //add the filters in local storage for persistent filtering after refresh
        // in local storage we should not store the search values
        let filterKeysToRemove = [...detailedSearchApiProps, 'search', 'search_global']
        let updateFilters = { ...filtersValues };
        filterKeysToRemove.forEach(key => {
            if (key in updateFilters) {
                delete updateFilters[key];
            }
        });
        // Safety net: never persist "cleared" values like [] / null / ''.
        for (const [key, val] of Object.entries(updateFilters)) {
            if (!isMeaningfulFilterValue(val) && val !== 0) {
                delete updateFilters[key]
            }
        }
        // Persist after the refresh dispatch, so storage work can't delay the API call.
        setTimeout(() => {
            try {
                setFiltersInLocalStorage(updateFilters, workQ?.slug)
            } catch (e) {
                // ignore storage errors (private mode / quota)
            }
        }, 0)
    }

    function restoreDefaultFiltersHandler() {
        const userLocations = getItemFromStorageSimple('userLocations')
        applyStandardWorkQueueDefaults(workQ, dispatch, userLocations)
        dispatch(workqueueActions.setInitialLoad(null))
        dispatch(filterActions.clearWorkQSearch())
        dispatch(filterActions.setCurrentPage(1))
        dispatch(workqueueActions.setRefreshApi())
    }

    function revertWorkQToInitialStateHandler() {
        removeStorageItem(workQ?.slug)
        dispatch(filterActions.setFiltersMultiple({}))
        dispatch(workqueueActions.setInitialLoad(null))
        dispatch(workqueueActions.setRefreshApi())
    }

    useEffect(() => {
        if (showModal) {
            return
        }
        let updatedFilters = { ...selectedFilters, ...searchParams }
        const hasCollectionRepNow = Array.isArray(updatedFilters?.attorney_collection_rep) && updatedFilters.attorney_collection_rep.length > 0
        const isJustRemoved = prevHasCollectionRepRef.current && !hasCollectionRepNow
        const dismissedForWorkQ = getCollectionRepDismissedForWorkQ(workQ?.slug)

        // If user removes the filter once, do not auto-add it again in this session.
        if (isJustRemoved) {
            setSkipAutoCollectionRep(true)
            if (workQ?.slug) {
                markCollectionRepDismissed(workQ.slug)
            }
        }

        const hasCollectionsRole = user?.roles?.some(role => role?.slug === 'collections')
        const hasCollectionsRepFilter = workQ?.filter_groups?.some(filter => filter?.key === 'attorney_collection_rep')
        const hasCollectionRepSelected = hasCollectionRepNow
        const shouldSkipAutoSelect = skipAutoCollectionRep || dismissedForWorkQ || isJustRemoved
        let didAutoSelectCollectionRep = false

        if (!shouldSkipAutoSelect && hasCollectionsRole && hasCollectionsRepFilter && !hasCollectionRepSelected) {
            const currentUserCollectionRep = buildCurrentUserCollectionsFilterOption(user)
            if (currentUserCollectionRep) {
                updatedFilters = {
                    ...selectedFilters,
                    attorney_collection_rep: [currentUserCollectionRep],
                }
                didAutoSelectCollectionRep = true
            }
        }

        setFiltersValues(updatedFilters)
        prevHasCollectionRepRef.current = Array.isArray(updatedFilters?.attorney_collection_rep) && updatedFilters.attorney_collection_rep.length > 0

        if (didAutoSelectCollectionRep) {
            commitFiltersToReduxAndStorage(updatedFilters)
        }
        // }
    }, [selectedFilters, searchParams, user, workQ, skipAutoCollectionRep, showModal])

    return <>        

        <FilterSearchContainer mainSelectAction={mainSelectAction} workQ={workQ} />

        {/* {filtersValues && <div className={classes.filters_wrapper}>
            {Object.values(filtersValues).some(item => item || (typeof(item) == "number")) && <SelectedFiltersDisplayMultiple filtersValues={filtersValues} workQ={workQ}/>}
        </div>} */}

        <SelectedFiltersDisplayMultiple filtersValues={filtersValues} workQ={workQ} generalAsyncSearchFilter={generalAsyncSearchFilter}/>

        {/* {(filtersValues && miscellaneous.numberOfObjectValues(selectedFilters, 'case_flags')) ? <BodySimpleModalV3 message={'Clear All Filters'}>
            <Button click={clearAllFiltersHandler}><i className="ti ti-x"></i></Button>
        </BodySimpleModalV3> : ''} */}


        {/* {getItemFromStorageSimple(workQ?.slug) && <BodySimpleModalV3 message={'Restore defaults'}>
            <Button click={restoreDefaultFiltersHandler}><i className="ti ti-restore"></i></Button>
        </BodySimpleModalV3>} */}
        <BodySimpleModalV3 message={'Reset'}>
            <Button click={restoreDefaultFiltersHandler}><i className="ti ti-restore"></i></Button>
        </BodySimpleModalV3>
        <SaveWorkQueueViewButton workQ={workQ} />
        <div>

            <Button click={openModalHandler} isDisabled={showModal} bypassisCaseArchived={true} btnStyle={'btn_dark'}>
                <i className="ti ti-filter-plus"></i>
                Filters
            </Button>

            {showModal && <OutsideClickComponent task={closeModalHandler} ignorePortalRootClicks>
                <div className={classes.container}>
                    <div className={classes.container_inner}>
                        <div>
                            <MegaMasterFilters mainSelectAction={mainSelectAction} generalAsyncSearchFilter={generalAsyncSearchFilter} filtersValues={filtersValues} workQ={workQ} payerTypeStatusAction={payerTypeStatusAction} removepayerTypeStatus={removepayerTypeStatusAction} practicePatientStatusAction={practicePatientStatusAction}/>

                            <div className={classes.filter_footer}>
                                <Button click={setFiltersHandler}>Set Filters</Button>
                            </div>
                        </div>
                    </div>
                </div>    
            </OutsideClickComponent>}
        </div>
    </>
}